
// Shared campus identity. Keep a solid fill beneath each gradient so class blocks
// and legend swatches stay campus-colored when background images do not render.
export const CAMPUS_COLORS = {
    'Busch': "bg-blue-600 bg-gradient-to-br from-blue-600 to-blue-700 border-blue-400 dark:bg-blue-700 dark:bg-gradient-to-br dark:from-blue-700 dark:to-blue-900 dark:border-blue-500",
    'College Ave': "!text-slate-950 dark:!text-white bg-yellow-400 bg-gradient-to-br from-yellow-400 to-yellow-600 border-yellow-400 dark:bg-yellow-700 dark:bg-gradient-to-br dark:from-yellow-700 dark:to-yellow-900 dark:border-yellow-500",
    'College Avenue': "!text-slate-950 dark:!text-white bg-yellow-400 bg-gradient-to-br from-yellow-400 to-yellow-600 border-yellow-400 dark:bg-yellow-700 dark:bg-gradient-to-br dark:from-yellow-700 dark:to-yellow-900 dark:border-yellow-500",
    'Cook/Douglass': "bg-green-700 bg-gradient-to-br from-green-700 to-emerald-800 border-green-400 dark:bg-green-700 dark:bg-gradient-to-br dark:from-green-700 dark:to-emerald-900 dark:border-green-500",
    'C/D': "bg-green-700 bg-gradient-to-br from-green-700 to-emerald-800 border-green-400 dark:bg-green-700 dark:bg-gradient-to-br dark:from-green-700 dark:to-emerald-900 dark:border-green-500",
    'Livingston': "bg-orange-700 bg-gradient-to-br from-orange-700 to-orange-700 border-orange-400 dark:bg-orange-700 dark:bg-gradient-to-br dark:from-orange-700 dark:to-orange-900 dark:border-orange-500",
    'Downtown New Brunswick': "bg-pink-700 bg-gradient-to-br from-pink-700 to-pink-800 border-pink-400 dark:bg-pink-600 dark:bg-gradient-to-br dark:from-pink-600 dark:to-pink-900 dark:border-pink-500",
    'Camden': "bg-rose-700 bg-gradient-to-br from-rose-700 to-red-700 border-rose-400 dark:bg-rose-700 dark:bg-gradient-to-br dark:from-rose-700 dark:to-red-900 dark:border-rose-500",
    'Newark': "bg-indigo-600 bg-gradient-to-br from-indigo-600 to-indigo-700 border-indigo-400 dark:bg-indigo-700 dark:bg-gradient-to-br dark:from-indigo-700 dark:to-indigo-900 dark:border-indigo-500",
    'Online': "bg-slate-500 bg-gradient-to-br from-slate-500 to-slate-600 border-slate-400 dark:bg-slate-600 dark:bg-gradient-to-br dark:from-slate-600 dark:to-slate-700 dark:border-slate-500",
    'Remote': "bg-cyan-700 bg-gradient-to-br from-cyan-700 to-sky-800 border-cyan-400 dark:bg-cyan-600 dark:bg-gradient-to-br dark:from-cyan-600 dark:to-sky-700 dark:border-cyan-500",
    'NB': "bg-blue-600 bg-gradient-to-br from-blue-600 to-indigo-600 border-blue-400 dark:bg-blue-700 dark:bg-gradient-to-br dark:from-blue-700 dark:to-indigo-800 dark:border-blue-500", // Default New Brunswick
    'Unknown': "bg-slate-600 bg-gradient-to-br from-slate-600 to-slate-700 border-slate-500 dark:bg-slate-700 dark:bg-gradient-to-br dark:from-slate-700 dark:to-slate-800 dark:border-slate-600",
    'Off Campus': "bg-slate-600 bg-gradient-to-br from-slate-600 to-slate-700 border-slate-500 dark:bg-slate-700 dark:bg-gradient-to-br dark:from-slate-700 dark:to-slate-800 dark:border-slate-600",
    'Study Abroad': "bg-purple-500 bg-gradient-to-br from-purple-500 to-purple-700 border-purple-400 dark:bg-purple-700 dark:bg-gradient-to-br dark:from-purple-700 dark:to-purple-900 dark:border-purple-500"
};

// Simple campus colors for badges and small elements
export const CAMPUS_BADGE_COLORS = {
    'Busch': 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',
    'College Ave': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300',
    'College Avenue': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300',
    'Cook/Douglass': 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',
    'C/D': 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',
    'Livingston': 'bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-300',
    'Downtown New Brunswick': 'bg-pink-100 text-pink-800 dark:bg-pink-900/20 dark:text-pink-300',
    'Camden': 'bg-rose-100 text-rose-800 dark:bg-rose-900/20 dark:text-rose-300',
    'Newark': 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/20 dark:text-indigo-300',
    'Online': 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-200',
    'Remote': 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900/20 dark:text-cyan-300',
    'NB': 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',
    'Unknown': 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-200',
    'Off Campus': 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-200',
    'Study Abroad': 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-300'
};

// Solid campus colors for simple backgrounds
export const CAMPUS_SOLID_COLORS = {
    'Busch': 'bg-blue-600',
    'College Ave': 'bg-amber-500',
    'College Avenue': 'bg-amber-500',
    'Cook/Douglass': 'bg-green-600',
    'C/D': 'bg-green-600',
    'Livingston': 'bg-orange-600',
    'Downtown New Brunswick': 'bg-pink-600',
    'Camden': 'bg-rose-600',
    'Newark': 'bg-indigo-600',
    'Online': 'bg-slate-600',
    'Remote': 'bg-cyan-600',
    'NB': 'bg-blue-700',
    'Unknown': 'bg-slate-700',
    'Off Campus': 'bg-slate-700',
    'Study Abroad': 'bg-purple-600'
};

// Text colors that pair well with the solid backgrounds above
export const CAMPUS_TEXT_COLORS = {
    'Busch': 'text-white',
    'College Ave': 'text-slate-900',
    'College Avenue': 'text-slate-900',
    'Cook/Douglass': 'text-white',
    'C/D': 'text-white',
    'Livingston': 'text-white',
    'Downtown New Brunswick': 'text-white',
    'Camden': 'text-white',
    'Newark': 'text-white',
    'Online': 'text-white',
    'Remote': 'text-white',
    'NB': 'text-white',
    'Unknown': 'text-white',
    'Off Campus': 'text-white',
    'Study Abroad': 'text-white'
};

export const CAMPUS_COLOR_KEY_ENTRIES = [
    'Busch',
    'College Avenue',
    'Cook/Douglass',
    'Livingston',
    'Downtown New Brunswick',
    'Newark',
    'Camden',
    'Online',
    'Remote',
    'Off Campus',
    'Study Abroad',
] as const;

// Utility function to get campus color with normalization
export const getCampusColor = (campus: string, type: 'gradient' | 'badge' | 'solid' = 'gradient'): string => {
    if (!campus || campus.trim() === '') return type === 'badge' ? 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-200' : 'bg-slate-500';

    const normalizedCampus = campus.trim();

    // Handle special cases
    if (normalizedCampus.toLowerCase().includes('online') || normalizedCampus.toLowerCase().includes('web')) {
        return type === 'gradient' ? CAMPUS_COLORS['Online'] :
            type === 'badge' ? CAMPUS_BADGE_COLORS['Online'] :
                CAMPUS_SOLID_COLORS['Online'];
    }

    if (normalizedCampus.toLowerCase().includes('remote')) {
        return type === 'gradient' ? CAMPUS_COLORS['Remote'] :
            type === 'badge' ? CAMPUS_BADGE_COLORS['Remote'] :
                CAMPUS_SOLID_COLORS['Remote'];
    }

    if (normalizedCampus.toLowerCase().includes('c/d')) {
        return type === 'gradient' ? CAMPUS_COLORS['C/D'] :
            type === 'badge' ? CAMPUS_BADGE_COLORS['C/D'] :
                CAMPUS_SOLID_COLORS['C/D'];
    }

    if (normalizedCampus.toLowerCase().includes('busch')) {
        return type === 'gradient' ? CAMPUS_COLORS['Busch'] :
            type === 'badge' ? CAMPUS_BADGE_COLORS['Busch'] :
                CAMPUS_SOLID_COLORS['Busch'];
    }

    if (normalizedCampus.toLowerCase().includes('college avenue')) {
        return type === 'gradient' ? CAMPUS_COLORS['College Avenue'] :
            type === 'badge' ? CAMPUS_BADGE_COLORS['College Avenue'] :
                CAMPUS_SOLID_COLORS['College Avenue'];
    }

    if (normalizedCampus.toLowerCase().includes('livingston')) {
        return type === 'gradient' ? CAMPUS_COLORS['Livingston'] :
            type === 'badge' ? CAMPUS_BADGE_COLORS['Livingston'] :
                CAMPUS_SOLID_COLORS['Livingston'];
    }

    // Return campus-specific style or default
    const colorMap = type === 'gradient' ? CAMPUS_COLORS :
        type === 'badge' ? CAMPUS_BADGE_COLORS :
            CAMPUS_SOLID_COLORS;

    return colorMap[normalizedCampus as keyof typeof colorMap] ||
        (type === 'badge' ? colorMap['Unknown'] : colorMap['Unknown']);
};

/**
 * Returns the appropriate text color (white or dark) for a given campus background
 * to ensure accessible contrast.
 */
export const getCampusTextColor = (campus: string): string => {
    if (!campus || campus.trim() === '') return 'text-white';

    const normalizedCampus = campus.trim();

    if (normalizedCampus.toLowerCase().includes('online') ||
        normalizedCampus.toLowerCase().includes('web') ||
        normalizedCampus.toLowerCase().includes('remote')) {
        return 'text-white';
    }

    if (normalizedCampus.toLowerCase().includes('college avenue') ||
        normalizedCampus.toLowerCase().includes('college ave')) {
        return 'text-slate-900';
    }

    return CAMPUS_TEXT_COLORS[normalizedCampus as keyof typeof CAMPUS_TEXT_COLORS] || 'text-white';
};

// Campus color mapping for Google Calendar - FINAL
export const GOOGLE_CALENDAR_COLORS: Record<string, string> = {
    // Blue -> Blueberry
    'Busch': '9',

    // Pink/Red
    'Downtown New Brunswick': '4', // Flamingo (Pink-ish Red)
    'Camden': '4',                 // Flamingo (Pink-ish Red)
    'NB': '11',                    // Tomato (Red)
    'Study Abroad': '11',          // Tomato (Red)

    // Yellow -> Banana
    'College Ave': '5',
    'College Avenue': '5',
    'Newark': '5',

    // Green -> Basil
    'Cook/Douglass': '10',
    'C/D': '10',

    // Orange -> Tangerine
    'Livingston': '6',

    // Gray -> Graphite
    'Remote': '8',
    'Online': '8',
    'Unknown': '8',
    'Off Campus': '8'
};
